import { SET_BULK_NEWS_AND_ADS, CLEAR_PARAMS_NEWS_AND_ADS, SET_PARAMS_NEWS_AND_ADS } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    type: "",
    is_approved: "",
    sort: "-created_at",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_NEWS_AND_ADS:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_NEWS_AND_ADS:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_NEWS_AND_ADS:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
